var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.65 44.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-link_off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.73.36a11.85,11.85,0,0,0-7,4.26A12.77,12.77,0,0,0,.07,13.1c0,3.85-.28,19.36.29,22C1.72,41.32,7,44.58,13.05,44.58c3.85,0,19.32.27,21.91-.28,5.62-1.19,9.62-5.91,9.63-12.62,0-3.66.26-19.62-.25-22C43,3.64,38,.06,31.64.07,27.77.07,12.33-.21,9.73.36Zm1.86,8.25c-4,.53-3.2,6.53.82,6S15.5,8.08,11.59,8.61ZM9.18,35.75h5.53l.06-18H9.23Zm15-15.38,0-2.67H18.53v18l5.59.06V27.29c0-1.44-.09-2.44.63-3.55a3.59,3.59,0,0,1,2.65-1.67,3,3,0,0,1,2.74,1.43c.67,1,.55,2.31.55,3.68v8.57h5.59V27.52c0-2.48.42-5.62-.87-7.46a7,7,0,0,0-5.85-2.5,7.45,7.45,0,0,0-3.45.69,4.37,4.37,0,0,0-2,2.12Z",
    transform: "translate(0 0)",
    fill: "#cacaca",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkOff);
export default __webpack_public_path__ + "static/media/link_off.34455f83a597e6667dc60479cad0cbdd.svg";
export { ForwardRef as ReactComponent };